import { type InsuranceCorporateIdentity } from "../types";

export function SalusBkkLogo({ className }: { className?: string }) {
  return (
    <svg
      width="512"
      height="512"
      viewBox="0 0 512 512"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M455.217 196.134L437.312 227.25H437.113V196.134H421.841V268.84H437.113V231.58H437.312L454.815 268.84H472.012L451.584 228.764L472.012 196.134H455.217Z"
        fill="url(#paint0_linear_31_4109)"
      />
      <path
        d="M40.0005 310.506V286.461H43.6494L50.7691 308.172H50.8424L57.8661 286.461H61.2756V310.506H59.1355V288.523H59.0701L51.9778 310.506H49.5028L42.206 288.523H42.1445V310.506H40.0005Z"
        fill="#5A5758"
      />
      <path
        d="M66.3677 310.506V293.682H68.372V310.506H66.3677ZM66.137 288.99V286.461H68.6154V288.99H66.137Z"
        fill="#5A5758"
      />
      <path
        d="M71.6206 295.285V293.683H74.3308V290.224L76.3425 289.357V293.683H79.7523V295.285H76.3425V306.073C76.3425 308.307 76.5781 308.839 78.179 308.839C78.852 308.839 79.3144 308.805 79.7523 308.74V310.471C79.1525 310.537 78.4786 310.572 77.8395 310.572C75.1343 310.572 74.3308 309.376 74.3308 307.307V295.284L71.6206 295.285Z"
        fill="#5A5758"
      />
      <path
        d="M91.2263 301.71C91.2263 305.208 91.2263 308.705 94.8739 308.705C96.5489 308.705 97.6146 307.606 97.9229 306.809C98.4228 305.507 98.5537 304.744 98.5537 299.814C98.5537 296.285 96.6483 294.952 94.7705 294.952C91.2953 294.952 91.2263 299.216 91.2263 301.71ZM98.689 293.653H100.662C100.597 295.254 100.559 296.086 100.559 296.948V311.104C100.559 314.8 99.424 317 94.6126 317C90.394 317 89.5601 314.034 89.6908 312.338H91.7026C91.5613 314.267 93.0038 315.402 94.8739 315.402C98.7888 315.402 98.5537 313.303 98.5537 308.272H98.4847C97.6146 309.705 96.0101 310.307 94.4049 310.307C89.5601 310.307 89.2207 306.142 89.2207 302.411C89.2207 298.515 89.256 298.48 89.7214 296.679C89.8907 295.986 91.0649 293.354 94.4703 293.354C96.1824 293.354 97.8842 294.22 98.6235 295.714L98.689 295.786V293.653Z"
        fill="#5A5758"
      />
      <path
        d="M115.357 293.683V310.506H113.613V308.64H113.54C112.37 310.074 111.169 310.836 109.299 310.836C105.82 310.836 104.849 308.308 104.849 305.576V293.684H106.855V305.247C106.855 305.714 106.759 309.238 109.669 309.238C112.37 309.238 113.344 306.711 113.344 305.545V293.683L115.357 293.683Z"
        fill="#5A5758"
      />
      <path
        d="M118.067 295.285V293.683H120.78V290.224L122.784 289.357V293.683H126.191V295.285H122.784V306.073C122.784 308.307 123.012 308.839 124.62 308.839C125.294 308.839 125.756 308.805 126.191 308.74V310.471C125.594 310.537 124.921 310.572 124.289 310.572C121.581 310.572 120.78 309.376 120.78 307.307V295.284L118.067 295.285Z"
        fill="#5A5758"
      />
      <path
        d="M138.071 300.913C138.071 297.185 137.475 294.952 134.258 294.952C131.049 294.952 130.448 297.185 130.448 300.913H138.071ZM130.448 302.511V303.813C130.448 306.142 131.082 309.238 134.258 309.238C136.767 309.238 138.011 307.637 137.972 305.377H140.081C139.846 309.438 137.641 310.836 134.258 310.836C131.352 310.836 128.442 309.667 128.442 304.579V300.449C128.442 295.584 130.482 293.354 134.258 293.354C140.081 293.354 140.081 297.519 140.081 302.511H130.448Z"
        fill="#5A5758"
      />
      <path
        d="M145.704 310.506H143.694V293.652H145.5V295.752H145.573C146.376 294.388 147.712 293.354 149.582 293.354C151.326 293.354 152.861 294.319 153.428 295.986C154.266 294.319 155.706 293.354 157.581 293.354C160.39 293.354 161.864 295.285 161.96 297.986V310.506H159.955V298.48C159.921 296.817 159.317 294.952 157.346 294.952C154.806 294.952 153.828 297.484 153.828 299.68V310.506H151.827V298.481C151.792 296.818 151.191 294.952 149.217 294.952C146.673 294.952 145.704 297.484 145.704 299.68V310.506Z"
        fill="#5A5758"
      />
      <path
        d="M185.248 299.748H180.368V297.947H187.392V309.973C185.248 310.636 183.012 310.974 180.734 310.974C172.878 310.974 173.441 303.146 173.441 298.48C173.441 293.821 172.878 285.995 180.734 285.995C185.356 285.995 187.727 287.96 187.626 292.619H185.487C185.487 289.458 184.118 287.795 180.734 287.795C175.511 287.795 175.585 292.419 175.585 298.48C175.585 304.541 175.511 309.172 180.734 309.172C182.578 309.172 184.118 308.909 185.248 308.472V299.748Z"
        fill="#5A5758"
      />
      <path
        d="M201.283 300.913C201.283 297.185 200.683 294.952 197.473 294.952C194.256 294.952 193.655 297.185 193.655 300.913H201.283ZM193.655 302.511V303.813C193.655 306.142 194.29 309.238 197.473 309.238C199.979 309.238 201.217 307.637 201.187 305.377H203.292C203.058 309.438 200.848 310.836 197.473 310.836C194.559 310.836 191.65 309.667 191.65 304.579V300.449C191.65 295.584 193.69 293.354 197.473 293.354C203.292 293.354 203.292 297.519 203.292 302.511H193.655Z"
        fill="#5A5758"
      />
      <path
        d="M208.24 295.285H205.527V293.683H208.24V290.856C208.24 289.262 208.471 286.323 212.551 286.323C212.855 286.323 213.194 286.396 213.691 286.461V288.124H212.185C210.246 288.124 210.246 289.859 210.246 290.825V293.683H213.659V295.285H210.246V310.506H208.24V295.285Z"
        fill="#5A5758"
      />
      <path
        d="M223.193 288.125H225.337V291.492H223.193V288.125ZM217.912 288.125H220.053V291.492H217.912V288.125ZM226.877 293.683V310.506H225.132V308.64H225.066C223.902 310.074 222.696 310.837 220.822 310.837C217.339 310.837 216.373 308.308 216.373 305.576V293.684H218.378V305.247C218.378 305.714 218.278 309.239 221.192 309.239C223.902 309.239 224.871 306.711 224.871 305.546V293.684L226.877 293.683Z"
        fill="#5A5758"
      />
      <path
        d="M231.099 310.506V286.462H233.104V295.752H233.173C234.138 294.35 235.444 293.354 237.249 293.354C241.429 293.354 241.867 296.449 241.867 298.649V310.506H239.859V298.753C239.859 296.784 239.089 294.953 236.745 294.953C234.943 294.953 233.104 296.186 233.104 299.948V310.507L231.099 310.506Z"
        fill="#5A5758"
      />
      <path
        d="M246.632 310.506H248.641V286.461H246.632V310.506Z"
        fill="#5A5758"
      />
      <path
        d="M260.881 286.462H262.89V301.116H262.954L268.773 293.683H271.118L265.133 301.181L271.518 310.506H268.978L262.954 301.346H262.89V310.506H260.881V286.462Z"
        fill="#5A5758"
      />
      <path
        d="M275.967 295.951H276.035C276.871 294.35 278.645 293.354 280.685 293.354V295.384C277.836 295.155 275.967 296.848 275.967 299.679V310.506H273.958V293.683H275.967V295.951Z"
        fill="#5A5758"
      />
      <path
        d="M291.735 301.913C288.852 302.012 284.507 301.683 284.507 305.775C284.507 307.675 285.477 309.238 287.548 309.238C289.856 309.238 291.735 307.177 291.735 304.978V301.913ZM291.862 308.441H291.796C290.726 310.039 289.084 310.836 287.017 310.836C284.003 310.836 282.367 308.806 282.367 305.874C282.367 299.982 288.321 300.58 291.735 300.315V298.917C291.735 296.449 290.992 294.952 288.321 294.952C286.482 294.952 285.003 295.852 285.003 297.848H282.859C283.029 294.619 285.543 293.354 288.483 293.354C290.191 293.354 293.737 293.523 293.737 297.817V306.273C293.737 307.476 293.737 308.541 293.936 310.506H291.862V308.441Z"
        fill="#5A5758"
      />
      <path
        d="M299.987 310.506H297.974V293.682H299.987V295.752H300.057C301.027 294.349 302.331 293.353 304.137 293.353C308.315 293.353 308.755 296.448 308.755 298.648V310.505H306.745V298.752C306.745 296.783 305.977 294.952 303.629 294.952C301.832 294.952 299.987 296.185 299.987 299.948V310.506Z"
        fill="#5A5758"
      />
      <path
        d="M312.907 286.462H314.919V301.116H314.985L320.804 293.683H323.151L317.155 301.181L323.548 310.506H321.009L314.985 301.346H314.919V310.506H312.907V286.462Z"
        fill="#5A5758"
      />
      <path
        d="M335.062 300.913C335.062 297.185 334.461 294.952 331.247 294.952C328.037 294.952 327.431 297.185 327.431 300.913H335.062ZM327.431 302.511V303.813C327.431 306.142 328.065 309.238 331.247 309.238C333.758 309.238 334.993 307.637 334.958 305.377H337.071C336.832 309.438 334.623 310.836 331.247 310.836C328.338 310.836 325.429 309.667 325.429 304.579V300.449C325.429 295.584 327.468 293.354 331.247 293.354C337.071 293.354 337.071 297.519 337.071 302.511H327.431Z"
        fill="#5A5758"
      />
      <path
        d="M342.723 310.506H340.721V293.682H342.723V295.752H342.792C343.766 294.349 345.068 293.353 346.872 293.353C351.055 293.353 351.493 296.448 351.493 298.648V310.505H349.485V298.752C349.485 296.783 348.719 294.952 346.379 294.952C344.566 294.952 342.723 296.185 342.723 299.948V310.506Z"
        fill="#5A5758"
      />
      <path
        d="M360.087 307.974H360.152L364.267 293.683H366.206L361.188 310.506H358.879L353.863 293.683H356.038L360.087 307.974Z"
        fill="#5A5758"
      />
      <path
        d="M377.798 300.913C377.798 297.185 377.198 294.952 373.984 294.952C370.77 294.952 370.17 297.185 370.17 300.913H377.798ZM370.17 302.511V303.813C370.17 306.142 370.8 309.238 373.984 309.238C376.489 309.238 377.73 307.637 377.697 305.377H379.799C379.569 309.438 377.36 310.836 373.984 310.836C371.071 310.836 368.161 309.667 368.161 304.579V300.449C368.161 295.584 370.2 293.354 373.984 293.354C379.799 293.354 379.799 297.519 379.799 302.511H370.17Z"
        fill="#5A5758"
      />
      <path
        d="M385.581 295.951H385.653C386.489 294.35 388.263 293.354 390.303 293.354V295.384C387.458 295.155 385.581 296.848 385.581 299.679V310.506H383.58V293.683H385.581V295.951Z"
        fill="#5A5758"
      />
      <path
        d="M397.228 310.836C393.583 310.836 392.144 309.073 392.175 305.506H394.222C394.222 307.805 394.758 309.338 397.332 309.338C399.275 309.338 400.206 308.242 400.206 306.372C400.206 301.978 392.614 303.116 392.614 297.549C392.614 294.449 394.758 293.354 397.701 293.354C401.046 293.354 402.116 295.652 402.116 298.215H400.138C400.041 296.085 399.476 294.952 397.197 294.952C395.762 294.952 394.621 295.882 394.621 297.384C394.621 301.583 402.215 300.449 402.215 306.073C402.215 309.237 400.376 310.836 397.228 310.836Z"
        fill="#5A5758"
      />
      <path
        d="M406.429 310.506V293.682H408.434V310.506H406.429ZM406.195 288.99V286.461H408.668V288.99H406.195Z"
        fill="#5A5758"
      />
      <path
        d="M420.723 298.515C420.826 296.419 420.056 294.952 417.744 294.952C416.507 294.952 415.469 295.652 415.035 296.883C414.765 297.649 414.569 299.948 414.569 302.178C414.569 305.208 414.569 309.238 417.682 309.238C420.318 309.238 420.653 307.575 420.753 305.545H422.766C422.927 310.074 419.713 310.836 418.143 310.836C412.428 310.836 412.428 306.342 412.428 302.178C412.428 300.514 412.49 297.882 412.921 296.618C413.798 294.22 415.699 293.354 418.017 293.354C420.922 293.354 422.893 294.986 422.735 298.515H420.723Z"
        fill="#5A5758"
      />
      <path
        d="M426.206 310.506V286.462H428.209V295.752H428.279C429.249 294.35 430.554 293.354 432.359 293.354C436.545 293.354 436.977 296.449 436.977 298.649V310.506H434.972V298.753C434.972 296.784 434.202 294.953 431.858 294.953C430.057 294.953 428.209 296.186 428.209 299.948V310.507L426.206 310.506Z"
        fill="#5A5758"
      />
      <path
        d="M450.27 300.913C450.27 297.185 449.669 294.952 446.46 294.952C443.25 294.952 442.645 297.185 442.645 300.913H450.27ZM442.645 302.511V303.813C442.645 306.142 443.278 309.238 446.46 309.238C448.963 309.238 450.205 307.637 450.171 305.377H452.275C452.045 309.438 449.836 310.836 446.46 310.836C443.547 310.836 440.638 309.667 440.638 304.579V300.449C440.638 295.584 442.677 293.354 446.46 293.354C452.275 293.354 452.275 297.519 452.275 302.511H442.645Z"
        fill="#5A5758"
      />
      <path
        d="M458.065 295.951H458.135C458.973 294.35 460.747 293.354 462.787 293.354V295.384C459.943 295.155 458.065 296.848 458.065 299.679V310.506H456.064V293.683H458.065V295.951Z"
        fill="#5A5758"
      />
      <path
        d="M463.715 295.285V293.683H466.429V290.224L468.439 289.357V293.683H471.845V295.285H468.439V306.073C468.439 308.307 468.669 308.839 470.273 308.839C470.94 308.839 471.414 308.805 471.845 308.74V310.471C471.244 310.537 470.578 310.572 469.943 310.572C467.229 310.572 466.429 309.376 466.429 307.307V295.284L463.715 295.285Z"
        fill="#5A5758"
      />
      <mask
        id="mask0_31_4109"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="40"
        y="194"
        width="49"
        height="76"
      >
        <path
          d="M40.1856 215.442C40.1856 237.088 72.0133 237.896 72.0133 250.987C72.0133 255.917 69.404 259.243 64.0625 259.243C55.3647 259.243 55.0484 253.401 55.0484 246.451H40V257.07C41.7243 263.577 46.3045 268.504 56.1953 269.784H68.557C78.564 268.703 88.0386 264.374 88.0386 249.075C88.0386 226.214 56.202 227.42 56.202 213.628C56.202 208.591 59.2423 205.871 64.3685 205.871C70.7568 205.871 71.7047 211.414 71.7047 216.85H87.0903C88.1372 201.64 80.4936 194.997 65.1073 194.997C45.8333 194.997 40.1829 204.061 40.1829 215.441"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_31_4109)">
        <path
          d="M40.1856 215.442C40.1856 237.088 72.0133 237.896 72.0133 250.987C72.0133 255.917 69.404 259.243 64.0625 259.243C55.3647 259.243 55.0484 253.401 55.0484 246.451H40V257.07C41.7243 263.577 46.3045 268.504 56.1953 269.784H68.557C78.564 268.703 88.0386 264.374 88.0386 249.075C88.0386 226.214 56.202 227.42 56.202 213.628C56.202 208.591 59.2423 205.871 64.3685 205.871C70.7568 205.871 71.7047 211.414 71.7047 216.85H87.0903C88.1372 201.64 80.4936 194.997 65.1073 194.997C45.8333 194.997 40.1829 204.061 40.1829 215.441"
          fill="url(#paint1_linear_31_4109)"
        />
      </g>
      <mask
        id="mask1_31_4109"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="40"
        y="194"
        width="49"
        height="76"
      >
        <path
          d="M40.1856 215.442C40.1856 237.088 72.0133 237.896 72.0133 250.987C72.0133 255.917 69.404 259.243 64.0625 259.243C55.3647 259.243 55.0484 253.401 55.0484 246.451H40V257.07C41.7243 263.577 46.3045 268.504 56.1953 269.784H68.557C78.564 268.703 88.0386 264.374 88.0386 249.075C88.0386 226.214 56.202 227.42 56.202 213.628C56.202 208.591 59.2423 205.871 64.3685 205.871C70.7568 205.871 71.7047 211.414 71.7047 216.85H87.0903C88.1372 201.64 80.4936 194.997 65.1073 194.997C45.8333 194.997 40.1829 204.061 40.1829 215.441"
          fill="white"
        />
      </mask>
      <g mask="url(#mask1_31_4109)">
        <mask
          id="mask2_31_4109"
          style={{ maskType: "luminance" }}
          maskUnits="userSpaceOnUse"
          x="40"
          y="193"
          width="50"
          height="77"
        >
          <path
            d="M40.0007 193.911H89.5402V269.781H40.0007V193.911Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask2_31_4109)">
          <path
            d="M55.9694 269.867C49.9948 269.067 43.7607 266.182 41.1588 260.436C39.1986 256.849 40.2537 252.715 40.0022 248.839C39.3293 246.527 40.5492 246.108 42.5036 246.413H55.0764C55.1771 250.528 54.8709 256.068 59.2397 258.199C63.2723 260.206 69.5411 259.377 71.2943 254.726C72.9337 251.011 71.4663 246.598 68.3425 244.139C62.9544 239.567 56.1315 237.145 50.4487 232.979C45.0404 229.342 40.4599 223.685 40.2125 216.94C39.5263 209.833 42.2182 201.744 48.9288 198.311C55.0187 195.035 62.2352 194.714 69.0034 195.093C74.8523 195.568 81.2334 197.562 84.4606 202.823C87.016 206.938 87.4387 211.989 87.1592 216.716C84.4032 217.243 81.5354 216.836 78.7252 216.955H71.6032C71.7851 212.993 71.1387 207.371 66.5293 206.236C62.7496 205.211 57.6546 206.69 56.6724 210.906C55.3705 214.697 57.2452 218.836 60.4213 221.077C67.6142 226.478 76.8734 228.918 83.0609 235.697C86.8932 239.834 88.5141 245.578 88.0469 251.125C87.7737 256.967 85.3862 263.113 80.1499 266.24C76.77 268.38 72.8377 269.289 68.9227 269.867"
            fill="url(#paint2_linear_31_4109)"
          />
        </g>
      </g>
      <mask
        id="mask3_31_4109"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="96"
        y="217"
        width="44"
        height="53"
      >
        <path
          d="M103.596 220.376C100.139 222.69 98.145 226.617 98.145 232.763H112.616C112.616 228.732 113.032 225.005 118.174 225.005C123.516 225.005 124.14 228.127 124.14 232.456V236.387C110.415 236.184 96.8838 236.889 96.8838 253.708C96.8838 261.885 100.108 268.783 108.69 269.785H113.316C118.42 269.218 122.031 266.72 124.77 262.161H124.978L125.61 268.912H139.342C139.027 265.793 138.61 262.567 138.61 259.443V234.073C138.61 224.805 136.201 217.055 117.436 217.055C111.77 217.055 106.952 217.959 103.597 220.377M111.356 253.098C111.356 244.038 116.813 244.639 124.14 244.34C124.14 249.876 125.503 261.155 116.812 261.155C111.986 261.155 111.355 256.722 111.355 253.098"
          fill="white"
        />
      </mask>
      <g mask="url(#mask3_31_4109)">
        <path
          d="M103.596 220.376C100.139 222.69 98.145 226.617 98.145 232.763H112.616C112.616 228.732 113.032 225.005 118.174 225.005C123.516 225.005 124.14 228.127 124.14 232.456V236.387C110.415 236.184 96.8838 236.889 96.8838 253.708C96.8838 261.885 100.108 268.783 108.69 269.785H113.316C118.42 269.218 122.031 266.72 124.77 262.161H124.978L125.61 268.912H139.342C139.027 265.793 138.61 262.567 138.61 259.443V234.073C138.61 224.805 136.201 217.055 117.436 217.055C111.77 217.055 106.952 217.959 103.597 220.377M111.356 253.098C111.356 244.038 116.813 244.639 124.14 244.34C124.14 249.876 125.503 261.155 116.812 261.155C111.986 261.155 111.355 256.722 111.355 253.098"
          fill="url(#paint3_linear_31_4109)"
        />
      </g>
      <mask
        id="mask4_31_4109"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="96"
        y="217"
        width="44"
        height="53"
      >
        <path
          d="M103.596 220.376C100.139 222.69 98.145 226.617 98.145 232.763H112.616C112.616 228.732 113.032 225.005 118.174 225.005C123.516 225.005 124.14 228.127 124.14 232.456V236.387C110.415 236.184 96.8838 236.889 96.8838 253.708C96.8838 261.885 100.108 268.783 108.69 269.785H113.316C118.42 269.218 122.031 266.72 124.77 262.161H124.978L125.61 268.912H139.342C139.027 265.793 138.61 262.567 138.61 259.443V234.073C138.61 224.805 136.201 217.055 117.436 217.055C111.77 217.055 106.952 217.959 103.597 220.377M111.356 253.098C111.356 244.038 116.813 244.639 124.14 244.34C124.14 249.876 125.503 261.155 116.812 261.155C111.986 261.155 111.355 256.722 111.355 253.098"
          fill="white"
        />
      </mask>
      <g mask="url(#mask4_31_4109)">
        <mask
          id="mask5_31_4109"
          style={{ maskType: "luminance" }}
          maskUnits="userSpaceOnUse"
          x="96"
          y="216"
          width="45"
          height="54"
        >
          <path
            d="M96.7305 216.851H140.804V269.785H96.7305V216.851Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask5_31_4109)">
          <path
            d="M108.342 269.867C105.43 269.318 102.527 268.183 100.576 265.858C98.2124 263.114 97.1377 259.472 96.9253 255.9C96.7441 254.044 96.8254 252.155 97.0116 250.307C97.5061 247.684 98.1281 244.94 99.8883 242.833C101.8 240.173 104.87 238.557 107.99 237.685C111.351 236.717 114.872 236.452 118.375 236.346C120.275 236.239 122.183 236.324 124.087 236.297C123.969 233.263 124.525 230.085 123.194 227.244C121.729 225.097 118.881 224.863 116.494 225.18C113.902 225.772 112.737 228.458 112.745 230.886C113.334 233.155 111.474 232.961 109.837 232.851H98.0681C98.0857 228.734 99.0404 224.362 102.088 221.401C104.608 219.271 107.733 217.992 110.983 217.51C113.398 217.058 115.872 217.009 118.326 216.974C121.701 217.142 125.094 217.292 128.355 218.289C131.227 219.041 134.024 220.531 135.861 222.943C137.434 224.932 138.158 227.488 138.434 230.02C138.922 235.024 138.641 240.068 138.716 245.094V262.087C138.711 264.322 139.769 267.178 138.974 269.015C134.507 268.934 130.016 269.001 125.538 268.979C125.343 266.749 125.178 264.509 124.909 262.299C123.598 263.984 122.238 266.038 120.311 267.249C118.275 268.844 115.645 269.57 113.07 269.87C111.495 269.867 109.918 269.867 108.342 269.868L108.342 269.867ZM116.047 260.974C119.011 261.599 122.213 259.62 123.062 256.758C124.119 253.941 124.188 250.857 124.176 247.877C124.182 245.957 124.448 243.468 121.688 244.499C119.026 244.533 116.253 244.671 113.925 246.079C111.475 248.183 111.3 251.657 111.469 254.635C111.548 257.085 112.478 260.127 115.136 260.812L115.377 260.974"
            fill="url(#paint4_linear_31_4109)"
          />
        </g>
      </g>
      <mask
        id="mask6_31_4109"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="151"
        y="196"
        width="16"
        height="73"
      >
        <path
          d="M151.111 268.912H166.752V196.205H151.111V268.912Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask6_31_4109)">
        <path
          d="M151.111 268.912H166.752V196.205H151.111V268.912Z"
          fill="url(#paint5_linear_31_4109)"
        />
      </g>
      <mask
        id="mask7_31_4109"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="178"
        y="218"
        width="43"
        height="52"
      >
        <path
          d="M204.935 218.059V253.301C204.935 257.833 204.065 261.155 199.17 261.155C194.267 261.155 193.404 257.833 193.404 253.301V218.059H178.049V258.838C178.049 265.165 183.221 269.058 189.548 269.785H194.398C198.823 269.326 202.164 267.586 204.719 263.778H204.935V268.912H220.838C220.514 265.586 220.291 262.161 220.291 258.838V218.059H204.935Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask7_31_4109)">
        <path
          d="M204.935 218.059V253.301C204.935 257.833 204.065 261.155 199.17 261.155C194.267 261.155 193.404 257.833 193.404 253.301V218.059H178.049V258.838C178.049 265.165 183.221 269.058 189.548 269.785H194.398C198.823 269.326 202.164 267.586 204.719 263.778H204.935V268.912H220.838C220.514 265.586 220.291 262.161 220.291 258.838V218.059H204.935Z"
          fill="url(#paint6_linear_31_4109)"
        />
      </g>
      <mask
        id="mask8_31_4109"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="178"
        y="218"
        width="43"
        height="52"
      >
        <path
          d="M204.935 218.059V253.301C204.935 257.833 204.065 261.155 199.17 261.155C194.267 261.155 193.404 257.833 193.404 253.301V218.059H178.049V258.838C178.049 265.165 183.221 269.058 189.548 269.785H194.398C198.823 269.326 202.164 267.586 204.719 263.778H204.935V268.912H220.838C220.514 265.586 220.291 262.161 220.291 258.838V218.059H204.935Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask8_31_4109)">
        <mask
          id="mask9_31_4109"
          style={{ maskType: "luminance" }}
          maskUnits="userSpaceOnUse"
          x="177"
          y="216"
          width="45"
          height="54"
        >
          <path
            d="M177.386 216.851H221.269V269.785H177.386V216.851Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask9_31_4109)">
          <path
            d="M189.302 269.868C186.714 269.4 184.133 268.593 182.026 266.967C179.363 265.005 177.812 261.655 178.023 258.338V217.955H193.433V254.527C193.675 256.815 194.068 259.687 196.574 260.617C199.137 261.621 202.662 261.148 204.042 258.529C205.251 255.391 204.698 251.985 204.824 248.695V217.955H220.345V261.531C220.536 263.605 220.565 265.708 220.804 267.795C221.459 269.688 219.06 268.791 217.933 268.978H204.823V263.865C203.38 265.767 201.644 267.509 199.437 268.542C197.956 269.249 196.351 269.499 194.773 269.868"
            fill="url(#paint7_linear_31_4109)"
          />
        </g>
      </g>
      <mask
        id="mask10_31_4109"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="304"
        y="196"
        width="50"
        height="73"
      >
        <path
          d="M304.409 196.201V268.907H331.412C337.885 268.907 353.972 268.102 353.972 249.672C353.972 239.699 351.139 232.757 340.317 231.244V231.041C348.606 229.432 352.756 223.386 352.756 215.031C352.756 199.526 343.142 196.201 331.511 196.201L304.409 196.201ZM319.681 207.38H329.087C334.244 207.38 337.885 211.303 337.885 216.644C337.885 223.694 333.235 225.908 329.895 225.908H319.681V207.38ZM319.681 237.084H328.579C336.268 237.084 338.7 241.011 338.7 247.458C338.7 257.626 331.412 257.726 328.178 257.726H319.681V237.084Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask10_31_4109)">
        <path
          d="M304.409 196.201V268.907H331.412C337.885 268.907 353.972 268.102 353.972 249.672C353.972 239.699 351.139 232.757 340.317 231.244V231.041C348.606 229.432 352.756 223.386 352.756 215.031C352.756 199.526 343.142 196.201 331.511 196.201L304.409 196.201ZM319.681 207.38H329.087C334.244 207.38 337.885 211.303 337.885 216.644C337.885 223.694 333.235 225.908 329.895 225.908H319.681V207.38ZM319.681 237.084H328.579C336.268 237.084 338.7 241.011 338.7 247.458C338.7 257.626 331.412 257.726 328.178 257.726H319.681V237.084"
          fill="url(#paint8_linear_31_4109)"
        />
      </g>
      <mask
        id="mask11_31_4109"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="304"
        y="196"
        width="50"
        height="73"
      >
        <path
          d="M304.409 196.201V268.907H331.412C337.885 268.907 353.972 268.102 353.972 249.672C353.972 239.699 351.139 232.757 340.317 231.244V231.041C348.606 229.432 352.756 223.386 352.756 215.031C352.756 199.526 343.142 196.201 331.511 196.201L304.409 196.201ZM319.681 207.38H329.087C334.244 207.38 337.885 211.303 337.885 216.644C337.885 223.694 333.235 225.908 329.895 225.908H319.681V207.38ZM319.681 237.084H328.579C336.268 237.084 338.7 241.011 338.7 247.458C338.7 257.626 331.412 257.726 328.178 257.726H319.681V237.084Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask11_31_4109)">
        <mask
          id="mask12_31_4109"
          style={{ maskType: "luminance" }}
          maskUnits="userSpaceOnUse"
          x="304"
          y="196"
          width="50"
          height="73"
        >
          <path
            d="M304.398 196.201H353.969V268.907H304.398V196.201Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask12_31_4109)">
          <path
            d="M304.32 268.978V196.167H334.247C339.218 196.553 344.7 197.5 348.252 201.261C352.156 205.218 353 211.157 352.764 216.511C352.449 221.052 350.691 225.881 346.688 228.404C345.198 230.004 341.851 230.368 340.723 231.294C345.283 231.805 349.895 234.133 351.89 238.408C354.131 242.851 354.2 248.053 353.851 252.921C353.314 257.277 351.523 261.777 347.87 264.42C343.709 267.92 337.967 268.749 332.65 268.975C323.208 268.981 313.762 268.976 304.319 268.977L304.32 268.978ZM319.73 257.528C323.286 257.755 326.878 257.588 330.45 257.64C333.509 257.347 336.608 255.733 337.696 252.71C339.046 249.085 338.997 244.846 337.415 241.297C335.618 237.93 331.486 236.987 327.928 237.186H319.73V257.528L319.73 257.528ZM319.73 225.736C323.398 225.962 327.101 225.796 330.785 225.847C333.996 225.376 336.778 222.962 337.398 219.758C338.641 215.738 337.24 210.89 333.577 208.617C329.937 206.731 325.729 207.575 321.774 207.394C320.68 207.395 319.219 207.03 319.73 208.627V225.736L319.73 225.736Z"
            fill="url(#paint9_linear_31_4109)"
          />
        </g>
      </g>
      <mask
        id="mask13_31_4109"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="365"
        y="196"
        width="51"
        height="73"
      >
        <path
          d="M398.479 196.201L380.574 227.317H380.374V196.201H365.102V268.907H380.374V231.647H380.574L398.077 268.907H415.274L394.845 228.831L415.274 196.201H398.479Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask13_31_4109)">
        <path
          d="M398.479 196.201L380.574 227.317H380.374V196.201H365.102V268.907H380.374V231.647H380.574L398.077 268.907H415.274L394.845 228.831L415.274 196.201H398.479Z"
          fill="url(#paint10_linear_31_4109)"
        />
      </g>
      <mask
        id="mask14_31_4109"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="231"
        y="216"
        width="40"
        height="54"
      >
        <path
          d="M245.75 252.443C245.65 254.757 245.75 256.975 246.459 258.589C247.266 260.201 248.792 261.002 251.624 261.002C254.448 261.002 256.881 259.19 256.881 255.765C256.881 244.991 231.796 247.409 231.796 231.196C231.796 220.224 242.717 216.902 251.923 216.902C261.638 216.902 270.435 221.53 269.628 232.507H255.665C255.665 228.986 255.265 226.871 254.248 225.963C253.34 225.059 252.124 224.852 250.607 224.852C247.475 224.852 245.75 226.871 245.75 230.292C245.75 238.349 270.836 237.943 270.836 254.256C270.836 263.119 263.554 269.763 251.716 269.763C239.276 269.763 230.986 266.645 231.796 252.444L245.75 252.443Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask14_31_4109)">
        <path
          d="M245.75 252.443C245.65 254.757 245.75 256.975 246.459 258.589C247.266 260.201 248.792 261.002 251.624 261.002C254.448 261.002 256.881 259.19 256.881 255.765C256.881 244.991 231.796 247.409 231.796 231.196C231.796 220.224 242.717 216.902 251.923 216.902C261.638 216.902 270.435 221.53 269.628 232.507H255.665C255.665 228.986 255.265 226.871 254.248 225.963C253.34 225.059 252.124 224.852 250.607 224.852C247.475 224.852 245.75 226.871 245.75 230.292C245.75 238.349 270.836 237.943 270.836 254.256C270.836 263.119 263.554 269.763 251.716 269.763C239.276 269.763 230.986 266.645 231.796 252.444H245.75"
          fill="url(#paint11_linear_31_4109)"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_31_4109"
          x1="446.932"
          y1="196.134"
          x2="446.932"
          y2="268.84"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#00ADEF" />
          <stop offset="1" stop-color="#1C63B7" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_31_4109"
          x1="64.0205"
          y1="195"
          x2="64.0205"
          y2="269.786"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#00ADEF" />
          <stop offset="1" stop-color="#1C63B7" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_31_4109"
          x1="64.7711"
          y1="193.911"
          x2="64.7711"
          y2="269.781"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#00ADEF" />
          <stop offset="1" stop-color="#1C63B7" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_31_4109"
          x1="118.113"
          y1="217.054"
          x2="118.113"
          y2="269.784"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#00ADEF" />
          <stop offset="1" stop-color="#1C63B7" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_31_4109"
          x1="118.767"
          y1="216.851"
          x2="118.767"
          y2="269.785"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#00ADEF" />
          <stop offset="1" stop-color="#1C63B7" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_31_4109"
          x1="158.927"
          y1="196.201"
          x2="158.927"
          y2="268.907"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#00ADEF" />
          <stop offset="1" stop-color="#1C63B7" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_31_4109"
          x1="199.441"
          y1="218.059"
          x2="199.441"
          y2="269.785"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#00ADEF" />
          <stop offset="1" stop-color="#1C63B7" />
        </linearGradient>
        <linearGradient
          id="paint7_linear_31_4109"
          x1="199.329"
          y1="216.851"
          x2="199.329"
          y2="269.785"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#00ADEF" />
          <stop offset="1" stop-color="#1C63B7" />
        </linearGradient>
        <linearGradient
          id="paint8_linear_31_4109"
          x1="329.188"
          y1="196.201"
          x2="329.188"
          y2="268.907"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#00ADEF" />
          <stop offset="1" stop-color="#1C63B7" />
        </linearGradient>
        <linearGradient
          id="paint9_linear_31_4109"
          x1="329.188"
          y1="196.201"
          x2="329.188"
          y2="268.907"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#00ADEF" />
          <stop offset="1" stop-color="#1C63B7" />
        </linearGradient>
        <linearGradient
          id="paint10_linear_31_4109"
          x1="390.193"
          y1="196.201"
          x2="390.193"
          y2="268.907"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#00ADEF" />
          <stop offset="1" stop-color="#1C63B7" />
        </linearGradient>
        <linearGradient
          id="paint11_linear_31_4109"
          x1="251.289"
          y1="216.901"
          x2="251.289"
          y2="269.762"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#00ADEF" />
          <stop offset="1" stop-color="#1C63B7" />
        </linearGradient>
      </defs>
    </svg>
  );
}

export const SalusBkk: InsuranceCorporateIdentity = {
  id: "salus-bkk",
  name: "Salus BKK",
  logo: SalusBkkLogo,
  backgroundColor: "white",
  textColor: "#000000",
  wildcard: "salus",
  type: "statutory",
};
